var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SimpleDataCard',{attrs:{"title":'Toplam B2B Sipariş Tutarı',"data":_vm.numberConverter(_vm.reportCompanyData.totalB2bSale,'TRY'),"description":'Tüm Zamanlar',"loading":_vm.stockDetailDataLoading,"route":"b2b-order-list"}})
}
var staticRenderFns = []

export { render, staticRenderFns }